import {
    apiRequest,
    // acmanajerialLevel,
    dokumenpelantikanDetail,
    generateDocument,
    generateDocumentPakta,
    generateDocumentSPP,
    generateDocumentSPMJ,
    generateDocumentSPMT,
    getDocPelantikan,
    getDocPakta,
    getDocSPP,
    getDocSPMJ,
    getDocSPMT,
    dokumenpelantikanInactive
} from "../../../../../services/adapters/kepegawaian/dokumenPelantikanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", dokumenpelantikanDetail, {
            params: query
        }, true)
    }

    // fetchLevel = async (query) => {
    //     return await apiRequest("get", acmanajerialLevel, {
    //         params: query
    //     }, true)
    // }
    fetchGenerateDocument = async (query) => {
        return await apiRequest("get", generateDocument, {
            params: query
        }, true)
    }
    fetchGenerateDocumentPakta = async (query) => {
        return await apiRequest("get", generateDocumentPakta, {
            params: query
        }, true)
    }
    fetchGenerateDocumentSPP = async (query) => {
        return await apiRequest("get", generateDocumentSPP, {
            params: query
        }, true)
    }
    fetchGenerateDocumentSPMJ = async (query) => {
        return await apiRequest("get", generateDocumentSPMJ, {
            params: query
        }, true)
    }
    fetchGenerateDocumentSPMT = async (query) => {
        return await apiRequest("get", generateDocumentSPMT, {
            params: query
        }, true)
    }
    fetchDetailDokpelantikan = async (query) => {
        return await apiRequest("get", getDocPelantikan, {
            params: query
        }, true)
    }
    fetchDetailDokPakta = async (query) => {
        return await apiRequest("get", getDocPakta, {
            params: query
        }, true)
    }
    fetchDetailDokSPP = async (query) => {
        return await apiRequest("get", getDocSPP, {
            params: query
        }, true)
    }
    fetchDetailDokSPMJ = async (query) => {
        return await apiRequest("get", getDocSPMJ, {
            params: query
        }, true)
    }
    fetchDetailDokSPMT = async (query) => {
        return await apiRequest("get", getDocSPMT, {
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", dokumenpelantikanInactive, {
            body: query
        }, true)
    }
}

export default DetailRepository